import { z } from 'zod';

import { CompSearch, schCompSearch } from '../types.ts';

export const replaceUndefinedWithEmptyString = <T extends Record<string, any>>(obj: T): T => {
  const newObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      newObj[key] = '';
    } else {
      newObj[key] = obj[key];
    }
  });
  return newObj as T;
};

export const toCompSearchFormValues = (search: CompSearch): z.input<typeof schCompSearch> => ({
  ...search,
  filters: Object.fromEntries(
    Object.entries(search.filters).map(([key, value]) => {
      if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
        return [key, replaceUndefinedWithEmptyString(value)];
      }
      return [key, value === undefined ? '' : value];
    }),
  ) as z.input<typeof schCompSearch>['filters'],
});

export const commitAppliedCompSearch = (form: {
  getValues: (name: 'search' | 'originalSearch') => unknown;
  setValue: (name: 'search' | 'originalSearch', value: z.input<typeof schCompSearch>) => void;
}) => {
  const originalSearch = schCompSearch.parse(form.getValues('originalSearch'));
  const appliedSearch = schCompSearch.parse(form.getValues('search'));
  const formSearch = toCompSearchFormValues(appliedSearch);
  form.setValue('search', formSearch);
  form.setValue('originalSearch', formSearch);
  return { originalSearch, appliedSearch };
};
